import { escapeHtml } from "@emkit/builder-core";
export const CODE_DEFAULTS = {
    code: 'function greet(name) {\n  return `Hello, ${name}!`;\n}\n\nconsole.log(greet("world"));',
    language: "javascript",
    title: "example.js",
    theme: "dark",
    showLineNumbers: true,
    radius: 8,
};
const THEMES = {
    dark: {
        bg: "#0f172a",
        headerBg: "#1e293b",
        fg: "#e2e8f0",
        muted: "#94a3b8",
        border: "#1e293b",
        gutter: "#475569",
    },
    light: {
        bg: "#f8fafc",
        headerBg: "#f1f5f9",
        fg: "#0f172a",
        muted: "#64748b",
        border: "#e2e8f0",
        gutter: "#94a3b8",
    },
};
export const codeWidget = {
    type: "code",
    defaultProps: CODE_DEFAULTS,
    renderHtml(props) {
        const theme = THEMES[props.theme ?? "dark"];
        const radius = props.radius ?? 8;
        const lines = (props.code ?? "").split("\n");
        const showNums = props.showLineNumbers ?? true;
        const header = props.title || props.language
            ? `<div style="display:flex;align-items:center;justify-content:space-between;padding:8px 14px;background:${theme.headerBg};color:${theme.muted};font-size:12px;border-bottom:1px solid ${theme.border};border-top-left-radius:${radius}px;border-top-right-radius:${radius}px;font-family:inherit">${props.title ? `<span>${escapeHtml(props.title)}</span>` : "<span></span>"}${props.language ? `<span style="text-transform:uppercase;letter-spacing:0.05em;font-size:11px">${escapeHtml(props.language)}</span>` : ""}</div>`
            : "";
        const body = showNums
            ? lines
                .map((ln, i) => `<div style="display:flex;min-height:1.5em"><span aria-hidden="true" style="flex-shrink:0;color:${theme.gutter};user-select:none;padding:0 14px 0 12px;text-align:right;min-width:2.5em">${i + 1}</span><span>${escapeHtml(ln) || "&nbsp;"}</span></div>`)
                .join("")
            : escapeHtml(props.code ?? "");
        const bodyRadius = props.title || props.language
            ? `border-bottom-left-radius:${radius}px;border-bottom-right-radius:${radius}px`
            : `border-radius:${radius}px`;
        return `<div class="emk-code" style="background:${theme.bg};border:1px solid ${theme.border};border-radius:${radius}px;overflow:hidden;font-family:inherit">${header}<pre style="margin:0;padding:${showNums ? "14px 0" : "14px 16px"};color:${theme.fg};font-size:13px;line-height:1.5;overflow-x:auto;${bodyRadius};font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace"><code>${body}</code></pre></div>`;
    },
};
//# sourceMappingURL=code.js.map